module.exports = __webpack_public_path__ + "img/Grupo 1331@2x.ca8b8de1.png";